// browser locale helper to show the default content in the browser language
const getBrowserLocale = () => {
  const { language } = window.navigator;
  const [defaultLng, defaultCountry] = language.split('-');

  return { defaultLng, defaultCountry };
};

export default getBrowserLocale;
